<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      >
      </Table>
    </template>
  </Content>
</template>

<script>
import Table from "@/components/Table";
import Content from "@/layout/Content";

import { getDigests as fetchData } from "@/api/digest";

const columnsOptions = {
  sortable: false,
  itemsName: "items",
  controls: true,
  editable: true,
  id: "id",
  search_list: [
    {
      label: "Поиск по ID",
      name: "digest_id",
      strong: true,
    },
    {
      label: "Поиск по названию",
      name: "name",
    },
  ],
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "name",
    label: "Название",
  },
  {
    prop: "start_date",
    label: "Дата начала",
    type: "date",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
